import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-most-viewed-products',
  templateUrl: './most-viewed-products.component.html',
  styleUrls: ['./most-viewed-products.component.css']
})
export class MostViewedProductsComponent implements OnInit {
  displayColumns: string[] = ["name", "count" ]
  dataSource = new MatTableDataSource<any>([])
  isLoading:boolean=false
  index: number = 0;
  size: number = 10;
  dataLength :number =0 ;
  data:any ={}; 
  constructor(private httpClient: HttpClient) { }

  ngOnInit() {

    this.getMostViewedProduct();
  }


  getMostViewedProduct(){
    this.data ={
      pagination: {  start: this.index, number: this.size },
      search: {
        predicateObject: {}
      },
      sort: {}
    } 
    this.httpClient.post(`/RecentlyViewdProduct/GetMostViewedProduct`,this.data).subscribe( (res:any)=>{
     this.dataSource=res.data; 
     this.dataLength = res.totalCount;
     this.isLoading=true;
    })
    err=>{
      this.isLoading=true;
      console.log(err.message)
    }
  }
  changePage(event) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getMostViewedProduct()
  }

  
}
